import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Alert, AlertTitle } from '@material-ui/lab';
import { Snackbar } from '@material-ui/core';

/**
 * @author IKlapouch
 * 13/10/2021
 */

const CustomAlert = ({
  success,
  error,
  warning,
  message,
  handleCloseAlert,
  snackbar,
  verticalAlign,
  horizontalAlign,
  autoClose
}) => {
  const { t } = useTranslation();

  const [state, setState] = useState({
    open: false,
    vertical: !!verticalAlign ? verticalAlign : 'top',
    horizontal: !!horizontalAlign ? horizontalAlign : 'center',
    severity: '',
    defaultMessage: ''
  })

  const { open, vertical, horizontal, severity, defaultMessage } = state;

  useEffect(() => {
    if (snackbar) {
      if (success) {
        setState({
          ...state,
          open: true,
          severity: 'success',
          defaultMessage: t('saveSuccess')
        })
        return;
      }

      if (error) {
        setState({
          ...state,
          open: true,
          severity: 'error',
          defaultMessage: t('saveError')
        })
        return;
      }

      if (warning) {
        setState({
          ...state,
          open: true,
          severity: 'warning',
          defaultMessage: t('warning')
        })
        return;
      }
    }
  }, [success, error, warning]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setState({ ...state, open: false });
    handleCloseAlert();
  }


  return (
    <>
      {
        snackbar
          ? (
            <Snackbar
              open={open}
              autoHideDuration={autoClose ? 6000 : undefined}
              onClose={handleClose}
              anchorOrigin={{ vertical, horizontal }}
              key={vertical + horizontal}
            >
              <Alert
                severity={severity}
                onClose={handleClose}
                sx={{ width: '100%' }}
              >
                {message ? message : defaultMessage}
              </Alert>
            </Snackbar>
          )

          : (
            <>
              {success &&
                <Grid item xs={12}>
                  <Alert severity="success" fullWidth onClose={handleCloseAlert}>
                    <AlertTitle>{t("success")}</AlertTitle>
                    {message ? message : t("saveSuccess")}
                  </Alert>
                </Grid>}
              {error &&
                <Grid item xs={12}>
                  <Alert severity="error" fullWidth onClose={handleCloseAlert}>
                    <AlertTitle>{t("error")}</AlertTitle>
                    {message ? message : t("saveError")}
                  </Alert>
                </Grid>}
              {warning &&
                <Grid item xs={12}>
                  <Alert severity="warning" fullWidth onClose={handleCloseAlert} >
                    <AlertTitle>{t("warning")}</AlertTitle>
                    {message ? message : t("warning")}
                  </Alert>
                </Grid>}
            </>
          )
      }
    </>
  );
};

export default CustomAlert;
